import m from "mithril";
import { MainLContent, PrimaryBoxFrameView, SimpleFooter, SimpleHeader } from "./hamajima-web";
import { APP_TITLE } from "./common";
import { getSerialCodes } from "./serial-codes";

import licenseSheetSample from "./img/license-sheet-sample.webp";

export class LoginPage {
  oncreate(vnode) {
    window.scrollTo(0, 0);
  }

  view(vnode) {
    return [
      m(SimpleHeader, APP_TITLE),
      m(MainLContent, [
        m("h2.m-txt-ttl2", "ご利用にあたって"),
        m(TopNoticeView),
        m(LoginView),
      ]),
      m(SimpleFooter),
    ];
  }
}

class LoginView {
  oninit(vnode) {
    vnode.state.serialCodes = getSerialCodes();
  }

  view(vnode) {
    return m(".[data-gs=12][data-gs-tab=1][daga-gs-sp=1][data-gs-group]", [
      m(".[data-gs-col=6]", [
        m(".login.matm", [
          m(".input-group", [
            m("label[for=org-code]", "組織コード"),
            m("input[type=text]#org-code.m-form-txt", {
              placeholder: "組織コードを入力してください",
              value: vnode.state.serialCodes.orgCode,
              oninput: e => {
                vnode.state.serialCodes.orgCode = e.target.value;
              },
            })
          ]),
          m(".input-group", [
            m("label[for=unit-id]", "シリアルコードユニットIDの先頭8文字"),
            m("input[type=text]#unit-id.m-form-txt", {
              placeholder: "シリアルコードユニットIDの先頭8文字を入力してください",
              value: vnode.state.serialCodes.unitId,
              oninput: e => {
                vnode.state.serialCodes.unitId = e.target.value;
              },
            }),
          ]),
        ]),
        m(".m-list-btn.link-position-center.mats", [
          m("ul[data-gs=12][data-gs-tab=2][data-gs-sp=1]", [
            m("li[data-gs-col=12]", [
              m("button[type=button].m-btn-common", {
                disabled: !vnode.state.serialCodes.validateInput(),
                onclick: e => {
                  vnode.state.serialCodes.getSerialCodes()
                    .then(data => {
                      console.log(data)
                      m.route.set("/download");
                    })
                    .catch(error => {
                      alert(error);
                    });
                }
              }, "確認"),
            ]),
          ]),
        ]),
        m(".m-box-frame.frame-danger", [
          m("p.m-txt-p", [
            "「シリアルコード通知シート」は、",
            m("strong", "2025年度以降ご採用分"),
            "のライセンス証書でご利用いただくことができます。",
          ]),
        ]),
      ]),
      m(".[data-gs-col=6]", [
        m(".m-list-image.image-position-center[data-gs-tab=2][data-gs-sp=1]", [
          m("ul[data-gs=12][data-gs-tab=2][data-gs-sp=1]", [
            m("li[data-gs-col=12]", [
              m("p.image-img", [
                m("img.bordered", {
                  src: licenseSheetSample,
                }),
              ]),
            ]),
          ]),
        ]),
      ]),
    ]);
  }
}

class TopNoticeView {
  view(vnode) {
    return m(PrimaryBoxFrameView, [
      m("ul.m-list-desc", [
        m("li", "浜島書店「学習者用デジタル版資料集（超教科書クラウド）」ご採用校の先生向けのページです。"),
        m("li", [
          "「シリアルコード通知シート」は、",
          m("strong", "2025年度以降ご採用分"), 
          "のライセンス証書でご利用いただくことができます。"
        ]),
        m("li", [
          "「学習者用デジタル版資料集」をご利用いただく生徒様に",
          m("strong", "「シリアルコード」"),
          "を通知するためのご案内をダウンロードしていただくことが可能です。",
          m("ul.m-list-desc", [
            m("li", "シリアルコードは、生徒様がご自身の超教科書クラウドアカウントに、ご購入いただいた教材を登録するために使用いたします。"),
            m("li", "シリアルコードは、ご利用いただく生徒様ごとに別のものを配布していただきますようお願いいたします。"),
          ]),
        ]),
        m("li", [
          "ダウンロードにあたっては、納品時にお届けしている",
          m("strong", "「ライセンス証書」"),
          "が必要です。",
        ]),
        m("li", "ライセンス証書が見当たらない場合は、浜島書店までお問い合わせください。")
      ]),
    ]);
  }
}